import { observable, action, makeObservable } from 'mobx';

class ReviewCycleViewModel {
  data;
  selected = false;

  constructor({data, selected}) {
    makeObservable(this, {
      data: observable,
      selected: observable,
      toggle: action
    });

    this.data = data;
    this.selected = selected;
  }

  toggle() {
    this.selected = !this.selected;
  }
}

export default ReviewCycleViewModel;
